import { Directive } from '@angular/core';

@Directive({
	selector: '[rbcSlotMarker]'
})
export class SlotMarkerDirective {}
